'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

var _SpotSuggestionModel = require('./SpotSuggestion/SpotSuggestionModel');

var _SpotSuggestionRender = require('./SpotSuggestion/SpotSuggestionRender');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Requires serviceConfig that fits contract for serviceUrl usage:
 * (namePrefix) => `${serviceConfig.serviceUrl}/search/spots?namePrefix=${namePrefix}`;
 */
var SpotSearch = function (_Component) {
  (0, _inherits3.default)(SpotSearch, _Component);

  function SpotSearch() {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, SpotSearch);

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    var _this = (0, _possibleConstructorReturn3.default)(this, (SpotSearch.__proto__ || (0, _getPrototypeOf2.default)(SpotSearch)).call(this));

    _this.onChange = function (event, _ref) {
      var newValue = _ref.newValue;

      _this.setState({
        value: newValue
      });
    };

    _this.onSearchFieldFocus = function () {
      if (window && window.analytics && window.analytics.track) {
        window.analytics.track('Focused Search', {
          location: 'navigation' // navigation | top of map | bottom of map
        });
      }
    };

    _this.onSuggestionsFetchRequested = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref3) {
        var value = _ref3.value;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this;
                _context.next = 3;
                return (0, _SpotSuggestionModel.getSuggestedSpots)(_this.props.serviceConfig, value);

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = value;
                _context.t3 = {
                  suggestions: _context.t1,
                  searchTerm: _context.t2
                };

                _context.t0.setState.call(_context.t0, _context.t3);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.onSuggestionsClearRequested = function () {
      _this.setState({
        suggestions: []
      });
    };

    _this.onSuggestionSelected = function (event, value) {
      var _value$suggestion = value.suggestion,
          name = _value$suggestion.name,
          _index = _value$suggestion._index,
          _id = _value$suggestion._id,
          href = _value$suggestion._source.href,
          suggestionIndex = value.suggestionIndex;
      var searchTerm = _this.state.searchTerm;

      if (window && window.analytics && window.analytics.track && !(window.analytics instanceof Array) // At least Safari + AdBlock 2.62 overwrite w.a
      ) {
          window.analytics.track('Clicked Search Results', {
            location: 'navigation', // navigation | top of map | bottom of map
            searchResultRank: suggestionIndex,
            destinationPage: _id, // This will be a URL after taxonomy API merged
            sourcePage: window.location.href,
            queryTerm: searchTerm,
            resultName: name,
            resultType: _index.indexOf('spot') > -1 ? 'spot' : 'location'
          }, function () {
            return _this.navigateToResult(href);
          });
        } else {
        _this.navigateToResult(href);
      }
    };

    _this.navigateToResult = function (href) {
      window.location.href = href;
    };

    _this.handleToggleSearchOnClick = function () {
      return _this.setState({
        isMobileExpanded: true
      });
    };

    _this.handleToggleSearchOffClick = function () {
      return _this.setState({
        isMobileExpanded: false,
        value: ''
      });
    };

    _this.theme = {
      container: 'quiver-spot-search__react-autosuggest__container',
      containerOpen: 'quiver-spot-search__react-autosuggest__container--open',
      input: 'quiver-spot-search__react-autosuggest__input',
      inputOpen: 'quiver-spot-search__react-autosuggest__input--open',
      inputFocused: 'quiver-spot-search__react-autosuggest__input--focused',
      suggestionsContainer: 'quiver-spot-search__react-autosuggest__suggestions-container',
      suggestionsContainerOpen: 'quiver-spot-search__react-autosuggest__suggestions-container--open',
      suggestionsList: 'quiver-spot-search__react-autosuggest__suggestions-list',
      suggestion: 'quiver-spot-search__react-autosuggest__suggestion',
      suggestionFirst: 'quiver-spot-search__react-autosuggest__suggestion--first',
      suggestionHighlighted: 'quiver-spot-search__react-autosuggest__suggestion--highlighted',
      sectionContainer: 'quiver-spot-search__react-autosuggest__section-container',
      sectionContainerFirst: 'quiver-spot-search__react-autosuggest__section-container--first',
      sectionTitle: 'quiver-spot-search__react-autosuggest__section-title'
    };
    _this.state = {
      value: '',
      suggestions: [],
      searchTerm: '',
      isMobileExpanded: false
    };
    return _this;
  }

  // Autosuggest will call this function every time you need to update suggestions.


  // Autosuggest will call this function every time you need to clear suggestions.


  (0, _createClass3.default)(SpotSearch, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          value = _state.value,
          suggestions = _state.suggestions,
          searchTerm = _state.searchTerm;
      var placeholder = this.props.placeholder;

      // Autosuggest will pass through all these props to the input element.

      var inputProps = {
        placeholder: placeholder,
        value: value,
        onChange: this.onChange,
        onFocus: this.onSearchFieldFocus
      };

      return _react2.default.createElement(_reactAutosuggest2.default, {
        theme: this.theme,
        multiSection: true,
        highlightFirstSuggestion: true,
        inputProps: inputProps,
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        onSuggestionSelected: this.onSuggestionSelected,
        getSectionSuggestions: _SpotSuggestionModel.getSectionSuggestions,
        getSuggestionValue: _SpotSuggestionModel.getSuggestionValue,
        renderInputComponent: (0, _SpotSuggestionRender.renderInputComponent)(this.state.isMobileExpanded, this.handleToggleSearchOffClick, this.handleToggleSearchOnClick),
        renderSectionTitle: _SpotSuggestionRender.renderSectionTitle,
        renderSuggestion: (0, _SpotSuggestionRender.renderSuggestion)(searchTerm)
      });
    }
  }]);
  return SpotSearch;
}(_react.Component);

SpotSearch.propTypes = {
  serviceConfig: _serviceConfigurationPropType2.default.isRequired,
  placeholder: _propTypes2.default.string
};
SpotSearch.defaultProps = {
  placeholder: 'Find surf spots'
};
exports.default = SpotSearch;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SpotSearch/SpotSearch.js
// module id = 655
// module chunks = 11